import { render, staticRenderFns } from "./PatchItem.vue?vue&type=template&id=1abfa63c&scoped=true&"
import script from "./PatchItem.vue?vue&type=script&lang=js&"
export * from "./PatchItem.vue?vue&type=script&lang=js&"
import style0 from "./PatchItem.vue?vue&type=style&index=0&id=1abfa63c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abfa63c",
  null
  
)

export default component.exports